module.exports = __webpack_public_path__ + "img/Poda Mal Realizada em Ramos Sintomáticos 1.bf865ad7.webp";